import { URL_DOMAIN_EPG } from "utils/ConstantsAndNum";

interface IConfig {
  [key: string]: string | any;
}

export default class Config {
  private _config: IConfig;
  constructor() {
    
    const hostname = window.location.hostname;

    let clientId: string;
    
    clientId = (hostname === URL_DOMAIN_EPG)
      ? "pao-admision-epg-web" 
      : "pao-admision-web";


    this._config = {
      API_HOST: process.env.REACT_APP_BASE_URL ?? "",
      AUTH_HOST: process.env.REACT_APP_AUTH_URL ?? "", // VALIDAR Y ELIMINAR
      STORAGE_AUTH: process.env.REACT_APP_STORAGE_AUTH ?? "",
      WEB_SOCKET_URL: process.env.REACT_APP_WEB_SOCKET ?? "", // VALIDAR Y ELIMINAR
      KEYCLOAK_CONFIG: {
        realm: "xpedition-candidate",
        clientId: clientId,
        url: process.env.REACT_APP_KEYCLOAK_URL,
      },
    };
  }
  public get(key: string) {
    return this._config[key];
  }
}
